export default __webpack_public_path__ + "static/media/plus-white.d36b0f0b.svg";